import React from "react"
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { OutboundLink } from "@assertiv/assertiv-gatsby-plugin-google-gtag"
import Wrapper from "@components/Wrapper"
import styles from "./AppCarousel.module.scss"
import apps from "../Data/apps.json";

const AppCarousel = props => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 4,
      slidesToSlide: 3, // optional, default to 1.
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  function getApps(){
    const apps = require("../Data/apps.json");
    let appDivs = [];
    for (const app of apps) {
      appDivs.push(<div key={app.appName + "_appDiv"} className={styles.tileDiv}>
        <span className={styles.helper}></span>
        <OutboundLink href={"apps/" + app.appName.toLocaleLowerCase() }>
          <img key={app.appName + "_appImg"} alt={app.appName} className={styles.appTileDiv} src={require("../../images/apps/" + app.icon)} />
        </OutboundLink>
      </div>);
    }
    return appDivs;
  }
    
  return (
    <section className="container-fluid bg-xl-light-gray">
      <div className="row ml-0 mr-0">
        <Wrapper className={"w-100 text-center"}>
          <div className="row bg-white">
              <h3
                className={
                  styles.title +
                  " proxima-nova--extra-bold text-secondary fs-30pt fs-lg-42pt"
                }
              >
                JUST SOME OF THE APPS WE SUPPORT
              </h3>
              <Carousel 
                className={styles.carouselStyle}
                responsive={responsive}
                autoPlay={true}
                autoPlaySpeed={2000}
                customTransition="transform 4000ms"
                transitionDuration={6000}
                removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
                infinite={true}
                itemClass="carousel-item-padding-40-px">
                {getApps()}
              </Carousel>
              <p
                className={
                  styles.carouselText +
                  " mx-auto"
                }
              >
                EngineID is a single point of access for your apps. Your users can reach GSuite, 
                Salesforce, Pipedrive or any other cloud-based tool, but they only have to 
                remember one login: their EngineID login.
              </p>
              <p
                className={
                  styles.carouselText + " " + styles.carouselTextLast +
                  " mx-auto"
                }
              >
                Best of all, you can do this without buying physical servers, installing
                complex software, having technicians or engineers on call to manage the
                servers or paying consulting rates to maintain a costly system for you.
              </p>
            </div>
        </Wrapper>
      </div>
    </section>
  )
};
export default AppCarousel

